import { useEffect } from "react";
import { TextField, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setDialog,
  resetForm,
  CapitalAmount,
} from "../../../../app/slices/capitalAmountSlice";
import { Controller, useForm } from "react-hook-form";
import { SelectCapitalAmountType } from "../../../../components/Selectors/SelectCapitalAmountType";
import { HiOutlineBanknotes, HiOutlineDocumentText } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const CapitalAmountForm = () => {
  const _CapitalAmount = useSelector(
    (state) => state.capitalAmount.capitalAmount
  );
  const _SearchBody = useSelector((state) => state.capitalAmount.searchBody);
  const loading = _CapitalAmount.loading;

  const isAdd = _CapitalAmount.form.id ? false : true;
  const { control, reset, handleSubmit } = useForm({
    defaultValues: {
      ..._CapitalAmount.form,
    },
  });

  const dispatch = useDispatch();

  const onSubmit = (data) => {
    if (isAdd) {
      dispatch(
        CapitalAmount.create({
          name: data.name,
          note: data.note,
          capital_amount_type_id: data.capital_amount_type_id,
        })
      );
    } else {
      dispatch(
        CapitalAmount.update(
          data.id,
          {
            name: data.name,
            note: data.note,
            capital_amount_type_id: data.capital_amount_type_id,
          },
          _SearchBody
        )
      );
    }
  };

  useEffect(() => {
    reset({
      ..._CapitalAmount.form,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_CapitalAmount.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => {
    dispatch(setDialog());
  };

  return (
    <FormDialog
      open={_CapitalAmount.dialog}
      onClose={handleClose}
      icon={<HiOutlineBanknotes />}
      title={isAdd ? "إضافة رأس مال جديد" : "تعديل رأس المال"}
      subtitle={
        isAdd
          ? "أدخل معلومات رأس المال لإضافته الى القائمة"
          : "قم بتحديث معلومات رأس المال ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
      saving={loading}
    >
      <SectionCard icon={<HiOutlineDocumentText />} title="معلومات رأس المال">
        <Grid item xs={12}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="الاسم"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="capital_amount_type_id"
            control={control}
            render={({ field: { onChange, value } }) => (
              <SelectCapitalAmountType
                fullWidth
                value={value ?? null}
                onChange={(e, newValue) =>
                  onChange(newValue ? newValue.id : null)
                }
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="note"
            control={control}
            render={({ field }) => (
              <TextField
                multiline
                rows={2}
                size="small"
                label="ملاحظات"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default CapitalAmountForm;
